import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useAuthInterceptor = (onLogout: () => void) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Erweitere den globalen fetch um Authentifizierung zu prüfen
    const originalFetch = window.fetch;
    
    window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
      const response = await originalFetch(input, init);
      
      // Prüfe auf 401 Unauthorized oder 403 Forbidden
      if (response.status === 401) {
        // Session abgelaufen - Benutzer abmelden und zur Login-Seite weiterleiten
        onLogout();
        navigate('/login', { replace: true });
        return response;
      }
      
      return response;
    };

    // Cleanup function
    return () => {
      window.fetch = originalFetch;
    };
  }, [navigate, onLogout]);

  useEffect(() => {
    // Listen for auth-session-expired events from apiClient (axios interceptor)
    const handleSessionExpired = (event: Event) => {
      const customEvent = event as CustomEvent;
      console.log('🔴 [useAuthInterceptor] Received auth-session-expired event:', customEvent.detail);
      
      // Navigate to login page
      navigate('/login', { replace: true });
    };

    window.addEventListener('auth-session-expired', handleSessionExpired);

    return () => {
      window.removeEventListener('auth-session-expired', handleSessionExpired);
    };
  }, [navigate]);
};
